import { cn } from "@/lib/utils";
import { Circle, CircleCheck } from "lucide-react";
import { useEffect, useState } from "react";
import { FaCircleCheck } from "react-icons/fa6";

const PasswordError = ({
  passwordErrorMin,
  passwordErrorUpperCaseChar,
  passwordErrorHasNumber,
  passwordErrorSpecialChar,
  passwordErrorLowerCaseChar
}) => {
  const [minLength, setMinLength] = useState(Boolean);
  const [hasUpperCaseChar, setHasUpperCaseChar] = useState(Boolean);
  const [hasLowerCaseChar, setHasLowerCaseChar] = useState(Boolean);
  const [hasNumber, setHasNumber] = useState(Boolean);
  const [isSpecialChar, setIsSpecialChar] = useState(Boolean);
  useEffect(() => {
    setMinLength(passwordErrorMin?.length >= 12 ? true : false);
    setHasUpperCaseChar(
      /[A-Z]/.test(passwordErrorUpperCaseChar) ? true : false
    );
    setHasLowerCaseChar(
      /[a-z]/.test(passwordErrorLowerCaseChar) ? true : false
    );
    setHasNumber(/\d/.test(passwordErrorHasNumber) ? true : false);
    setIsSpecialChar(
      /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(passwordErrorSpecialChar)
        ? true
        : false
    );
  }, [
    passwordErrorMin,
    passwordErrorUpperCaseChar,
    passwordErrorSpecialChar,
    passwordErrorHasNumber,
    passwordErrorLowerCaseChar
  ]);

  return (
    <div className="grid gap-2">
      <div className="flex gap-2">
        {passwordErrorMin === undefined ||
          minLength === false ||
          passwordErrorMin?.includes(" ") ? (
          <Circle className="w-[14px] h-[14px] text-gray-60" />
        ) : (
          <FaCircleCheck className="w-[14px] h-[14px] text-primary0" />
        )}
        <p
          className={cn(
            "text-xs ",
            passwordErrorMin === undefined ||
              minLength === false ||
              passwordErrorMin?.includes(" ")
              ? "text-gray-70"
              : "text-primary0"
          )}
        >
          12 characters long
        </p>
      </div>
      <div className="flex gap-2">
        {passwordErrorUpperCaseChar === undefined ||
          hasUpperCaseChar === false ? (
          <Circle className="w-[14px] h-[14px] text-gray-60" />
        ) : (
          <FaCircleCheck className="w-[14px] h-[14px] text-primary0" />
        )}

        <p
          className={cn(
            "text-xs ",
            passwordErrorUpperCaseChar === undefined ||
              hasUpperCaseChar === false
              ? "text-gray-70"
              : "text-primary0"
          )}
        >
          One uppercase
        </p>
      </div>
      <div className="flex gap-2">
        {passwordErrorLowerCaseChar === undefined ||
          hasLowerCaseChar === false ? (
          <Circle className="w-[14px] h-[14px] text-gray-60" />
        ) : (
          <FaCircleCheck className="w-[14px] h-[14px] text-primary0" />
        )}

        <p
          className={cn(
            "text-xs ",
            passwordErrorLowerCaseChar === undefined ||
              hasLowerCaseChar === false
              ? "text-gray-70"
              : "text-primary0"
          )}
        >
          One lowercase
        </p>
      </div>

      <div className="flex gap-2">
        {passwordErrorHasNumber === undefined || hasNumber === false ? (
          <Circle className="w-[14px] h-[14px] text-gray-60" />
        ) : (
          <FaCircleCheck className="w-[14px] h-[14px] text-primary0" />
        )}
        <p
          className={cn(
            "text-xs ",
            passwordErrorHasNumber === undefined || hasNumber === false
              ? "text-gray-70"
              : "text-primary0"
          )}
        >
          One number
        </p>
      </div>
      <div className="flex gap-2">
        {passwordErrorSpecialChar === undefined || isSpecialChar === false ? (
          <Circle className="w-[14px] h-[14px] text-gray-60" />
        ) : (
          <FaCircleCheck className="w-[14px] h-[14px] text-primary0" />
        )}
        <p
          className={cn(
            "text-xs ",
            passwordErrorSpecialChar === undefined || isSpecialChar === false
              ? "text-gray-70"
              : "text-primary0"
          )}
        >
          One $pecial Character
        </p>
      </div>
      {passwordErrorMin?.includes(" ") ? (
        <div className="flex gap-2">
          <Circle className="w-[14px] h-[14px] text-gray-60" />

          <p className="text-xs">Whitespace not allow</p>
        </div>
      ) : null}
    </div>
  );
};

const ConfirmPasswordError = ({ password, confirmNewPassword }) => {
  return (
    <>
      {confirmNewPassword !== "" && (
        <div className="flex gap-2">
          {password !== confirmNewPassword ? (
            <Circle className="w-[14px] h-[14px] text-gray-60" />
          ) : (
            <FaCircleCheck className="w-[14px] h-[14px] text-primary0" />
          )}

          <p
            className={cn(
              "text-xs ",
              password !== confirmNewPassword ? "text-gray-70" : "text-primary0"
            )}
          >
            {confirmNewPassword === ""
              ? ""
              : password !== confirmNewPassword
                ? "Password do not match"
                : "Password match"}
          </p>
        </div>
      )}
    </>
  );
};

export { PasswordError, ConfirmPasswordError };
